import React from "react";
import { useTranslation } from "react-i18next";

function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("appLanguage", lang); // save preference
  };

  return (
    <select
      className="form-select"
      style={{ width: "100px", lineHeight: 1 }}
      onChange={(e) => changeLang(e.target.value)} // pass selected lang
      defaultValue={localStorage.getItem("appLanguage") || "en"} // restore saved lang
    >
      <option value="en">English</option>
      <option value="hi">Hindi</option>
    </select>
  );
}

export default LanguageSwitcher;
